<template>
    <div class="a-vg-wrapper game-switcher">
        <div id='switcherVdog' class="a-vg-c--game-switcher">
          <game-button
            class="single-game"
            v-for="(game, index) in gameList"
            v-bind:key="index"
            :imageLink="game.imageLink"
            :imageAlt="game.imageAlt"
            :isActiveButton="isActiveButton(index)"
            @setSwipe="setSwipe(index)"/>
        </div>
    </div>
</template>
<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import GameButton from '@/components/common/GameButton.vue'

export default {
  components: {
    'game-button': GameButton
  },
  props: {
    'gameList': {
      type: Array,
      default: function () {
        return []
      }
    },
    'currentGameIndex': {
      type: Number,
      default: 0
    }
  },
  methods: {
    isActiveButton (index) {
      return index === this.currentGameIndex
    },
    setSwipe (index) {
      if (!this.isActiveButton(index)) {
        eventBus.$emit(EventConstants.CHANGE_GAME_ACTION, index, 'force')
      }
    }
  }
}
</script>
